import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { DateField } from "./DateField";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";

export function ReceiptButton({ projectId, onDone }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ kind: "profit", date: new Date().toISOString().slice(0, 10), amount: "", reference: "" });
  const [err, setErr] = useState("");
  const go = async () => {
    setErr("");
    try { const { data } = await api.post(`/projects/${projectId}/receipts`, { ...f, amount: Number(f.amount) }); toast.success(`Receipt recorded in ${data.quarter}`); setOpen(false); onDone?.(); }
    catch (e) { setErr(errMsg(e)); }
  };
  return (<>
    <Button variant="outline" size="sm" onClick={() => setOpen(true)} data-testid="record-receipt-btn">Record receipt</Button>
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent><DialogHeader><DialogTitle className="font-heading">Record equity return or profit received</DialogTitle></DialogHeader>
        <div className="grid gap-3 sm:grid-cols-2">
          <div className="space-y-1"><Label className="text-xs">Type</Label><select className="h-10 w-full rounded-md border bg-background px-2 text-sm" value={f.kind} onChange={(e) => setF({ ...f, kind: e.target.value })} data-testid="receipt-kind">
            <option value="profit">Profit</option><option value="equity_return">Equity return</option></select></div>
          <div className="space-y-1"><Label className="text-xs">Date received</Label><DateField value={f.date} onChange={(v) => setF({ ...f, date: v })} testid="receipt-date" /></div>
          <div className="space-y-1"><Label className="text-xs">Amount (£)</Label><Input type="number" value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value })} data-testid="receipt-amount" /></div>
          <div className="space-y-1"><Label className="text-xs">Reference</Label><Input value={f.reference} onChange={(e) => setF({ ...f, reference: e.target.value })} data-testid="receipt-reference" /></div>
        </div>
        {err && <div className="text-sm font-medium text-primary" data-testid="receipt-error">{err}</div>}
        <DialogFooter><Button onClick={go} data-testid="receipt-save-btn">Record</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  </>);
}
